exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".download-outer-file-box {\n    border: 1px solid #cecece;\n    background-color: #fff;\n    margin-bottom:10px;\n    padding: 10px 20px;\n    float: left;\n    width: 100%;\n\t-webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/rank-predictor/rank-predictor.component.css
// module id = ../../../../../src/app/home/rank-predictor/rank-predictor.component.css
// module chunks = common